import React, {useEffect, useRef, useState} from "react";
import {useSubheader} from "../../../_metronic/layout";
import {useTranslation} from "react-i18next";
import makeRequest from "../../api/makeRequest";
import PropTypes from 'prop-types';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import clsx from 'clsx';
import {
	AllInclusive as AllInclusiveIcon,
	Check,
	Extension as ExtensionIcon,
	Payment as PaymentIcon
} from '@material-ui/icons';
import {Button, Step, StepConnector, StepLabel, Stepper, Typography,Modal,Fade,Backdrop } from '@material-ui/core';
import Invoice from "../../components/Invoice";
import {useAlert} from "react-alert";
import moment from "moment-jalaali";
import {Link, useLocation} from "react-router-dom";
import OfferBar from "../../components/OfferBar";



const useQontoStepIconStyles = makeStyles({
	root: {
		color: '#eaeaf0',
		display: 'flex',
		height: 22,
		alignItems: 'center',
	},
	active: {
		color: '#784af4',
	},
	circle: {
		width: 8,
		height: 8,
		borderRadius: '50%',
		backgroundColor: 'currentColor',
	},
	completed: {
		color: '#784af4',
		zIndex: 1,
		fontSize: 18,
	},
});

function QontoStepIcon(props) {
	const classes = useQontoStepIconStyles();
	const {active, completed} = props;

	return (
		<div
			className={clsx(classes.root, {
				[classes.active]: active,
			})}
		>
			{completed ? <Check className={classes.completed}/> : <div className={classes.circle}/>}
		</div>
	);
}

QontoStepIcon.propTypes = {
	/**
	 * Whether this step is active.
	 */
	active: PropTypes.bool,
	/**
	 * Mark the step as completed. Is passed to child components.
	 */
	completed: PropTypes.bool,
};

const ColorlibConnector = withStyles({
	alternativeLabel: {
		top: 22,
	},
	active: {
		'& $line': {
			backgroundImage:
				'linear-gradient( 136deg, rgb(255 152 0) 0%, rgb(228 149 32) 50%, rgb(247 167 50) 100%)',
		},
	},
	completed: {
		'& $line': {
			backgroundImage:
				'linear-gradient( 136deg, rgb(255 152 0) 0%, rgb(228 149 32) 50%, rgb(247 167 50) 100%)',
		},
	},
	line: {
		height: 3,
		border: 0,
		backgroundColor: '#eaeaf0',
		borderRadius: 1,
	},
})(StepConnector);

const useColorlibStepIconStyles = makeStyles({
	root: {
		backgroundColor: '#ccc',
		zIndex: 1,
		color: '#fff',
		width: 50,
		height: 50,
		display: 'flex',
		borderRadius: '50%',
		justifyContent: 'center',
		alignItems: 'center',
	},
	active: {
		backgroundImage:
			'linear-gradient( 136deg, rgb(255 152 0) 0%, rgb(228 149 32) 50%, rgb(247 167 50) 100%)',
		boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
	},
	completed: {
		backgroundImage:
			'linear-gradient( 136deg, rgb(255 152 0) 0%, rgb(228 149 32) 50%, rgb(247 167 50) 100%)',
	},
});

function ColorlibStepIcon(props) {
	const classes = useColorlibStepIconStyles();
	const {active, completed} = props;

	const icons = {
		1: <ExtensionIcon/>,
		2: <PaymentIcon/>,
		3: <AllInclusiveIcon/>,
	};

	return (
		<div
			className={clsx(classes.root, {
				[classes.active]: active,
				[classes.completed]: completed,
			})}
		>
			{icons[String(props.icon)]}
		</div>
	);
}

ColorlibStepIcon.propTypes = {
	/**
	 * Whether this step is active.
	 */
	active: PropTypes.bool,
	/**
	 * Mark the step as completed. Is passed to child components.
	 */
	completed: PropTypes.bool,
	/**
	 * The label displayed in the step icon.
	 */
	icon: PropTypes.node,
};

const useStyles = makeStyles((theme) => ({
	root: {
		width: '100%',
	},
	button: {
		marginRight: theme.spacing(1),
		color:"white",
		backgroundColor:"#ff9800"
	},
	instructions: {
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(1),
	},
	modal: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		border: '2px solid #000',
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 3),
	},
}));

function useQuery() {
	return new URLSearchParams(useLocation().search);
}

const digits = (Number)=>{
	Number+= '';
	Number= Number.replace(',', ''); Number= Number.replace(',', ''); Number= Number.replace(',', '');
	Number= Number.replace(',', ''); Number= Number.replace(',', ''); Number= Number.replace(',', '');
	const x = Number.split('.');
	let y = x[0];
	const z= x.length > 1 ? '.' + x[1] : '';
	const rgx = /(\d+)(\d{3})/;
	while (rgx.test(y))
		y= y.replace(rgx, '$1' + ',' + '$2');
	return y+ z;
}
export const PlansPage = () => {
	const { t } = useTranslation('common')
	function getStepContent(step) {
		switch (step) {
			case 0:
				return t('SelectPlan');
			case 1:
				return t('Pay');
			case 2:
				return t('PaymentStatus');
			default:
				return 'Unknown step';
		}
	}
	function getSteps() {
		return [t('SelectPlans'), t('ViewInvoices'), t('UseService')];
	}

	const suhbeader = useSubheader();
	suhbeader.setTitle(t('Plans'));
	let query = useQuery();

	const [plans, setPlans] = useState([])
	const [videoLimits, setVideoLimits] = useState([])
	const [userLimits, setUserLimits] = useState([])
	const [selectedVideoLimit, setSelectedVideoLimit] = useState('')
	const [selectedUserLimit, setSelectedUserLimit] = useState('')
	const [selectedMonth, setSelectedMonth] = useState(1)
	const [selectedPercent, setSelectedPercent] = useState(1)
	const [selectedPlan, setSelectedPlan] = useState(null)
	const [coupon, setCoupon] = useState('')

	useEffect(() => {
		moment.loadPersian();
		const getPlans = async () => {
			try {
				/*const {data:TEST} = await makeRequest('buyPlan', {plan_id:6,month:1})
				console.log(TEST)
*/
				const {data} = await makeRequest('getPlans', {})
				const plansArr = data.plans || []
				let listVideoLimits = []
				let listUserLimits = []
				plansArr.forEach((plan) => {
					if (!listVideoLimits.includes(plan.video_limit)) listVideoLimits.push(plan.video_limit)
					if (!listUserLimits.includes(plan.max_user)) listUserLimits.push(plan.max_user)
				})

				setVideoLimits(listVideoLimits)
				setUserLimits(listUserLimits)
				setPlans(plansArr)
			} catch (e) {
				console.log(e)
			}
		}

		getPlans()
	}, [])

	const [queryField,setQueryFields] = useState(null)
	const [isPaymentEnd,setIsPaymentEnd] = useState(false)
	const classes = useStyles();
	const [open, setOpen] = React.useState(false);

	const handleOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};
	const [activeStep, setActiveStep] = React.useState(0);
	const steps = getSteps();

	useEffect(()=>{
		const qStep = query.get("step")
		const qState = query.get("state")
		const qTransactionId = query.get("transactionId")
		const qErr = query.get("err")
		const qErrCode = query.get("err_code")
		const qPlanId = Number(query.get("plan_id"))
		setQueryFields({
			qStep,
			qState,
			qTransactionId,
			qErr,
			qErrCode,
			qPlanId
		})
		if(qPlanId){
			plans.forEach(q=>{
					if(q.public_id === queryField.qPlanId){
						setSelectedPlan(q)
					}
			})
		}
		if(qState === 'OK') setIsPaymentEnd(true)
		if(qStep === '2') setActiveStep(2)
	},[plans])

	const alert = useAlert()


	const handleNext = () => {
		if(!selectedPlan) return alert.error(t('ChoosePlan'))
		setActiveStep((prevActiveStep) => prevActiveStep + 1);
	};

	const handleBack = (goStep = null) => {
		if(goStep !== null) return setActiveStep(goStep);
		setActiveStep((prevActiveStep) => prevActiveStep - 1);
	};

	const [payFormLoading,setPayFormLoading] = useState(false)
	const [payFormData,setPayFormData] = useState(null)
	const payFormRef = useRef()
	const handlePay = () => {
		const pay = async () => {
			try {
				setPayFormLoading(true)
				let params = {
					plan_id:selectedPlan.public_id,
					month:selectedMonth
				}
				if(coupon) params.coupon = coupon
				const {data} = await makeRequest('buyPlan', params,{},'https://online44.bellmeet.com/')

				const {payForm} = data
				setPayFormData(payForm)
			} catch (e) {
				console.log(e)
			}
		}

		pay().then(()=>{
			if(payFormRef.current)	payFormRef.current.submit()
		})
	};

	return (
		<>
			<div className={classes.root}>
				{payFormData && (
					<form ref={payFormRef} action={payFormData.action} method='POST'>
						<input type='hidden' name='token' value={payFormData.token}/>
						<input type='hidden' name='RedirectURL' value={payFormData.RedirectURL}/>
					</form>
				)}
				<OfferBar/>
				<Stepper style={{direction: "ltr"}} alternativeLabel activeStep={activeStep} connector={<ColorlibConnector/>}>
					{steps.map((label) => (
						<Step key={label}>
							<StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
						</Step>
					))}
				</Stepper>
				<div>
					<div className="text-center my-10 step-navigator">
						<Typography className={classes.instructions}>{getStepContent(activeStep)}</Typography>
						<div>
							<Button
								variant="contained"
								color="primary"
								onClick={activeStep !== 1 ? handleNext : handlePay}
								disabled={activeStep === 2 || isPaymentEnd || payFormLoading}
								className={classes.button}
								size="large"
							>
								{activeStep === 1 ? t('Payment') : t('NextPage')}
							</Button>
							<Button
								disabled={activeStep === 0 || isPaymentEnd || payFormLoading}
								onClick={()=> {
									if(activeStep === 2 && (queryField && queryField.qState !== 'OK')) return handleBack(0)
									handleBack()
								}}
								className={classes.button}
								variant="contained"
								size="large"
								color="primary"
							>
								{t('PreviousPage')}
							</Button>
						</div>
					</div>

					{activeStep === 0 && (
						<div style={{direction: "rtl"}} className={'plans-wrap'}>
							<div className={'plan-filter'}>
								<span className="video">{t('NumberVideo')}</span>
								<ul>
									<li onClick={() => setSelectedVideoLimit('')}
											className={selectedVideoLimit === '' ? 'active' : ''}>{t('ECOMMERCE.COMMON.ALL')}
									</li>
									{videoLimits.map(((value, index) => {
										return (
											<li onClick={() => setSelectedVideoLimit(value)}
													className={selectedVideoLimit === value ? 'active' : ''} key={index}>{value} {t('Video')} </li>
										)
									}))}
								</ul>
								<span className="user">{t('NumberUser')}</span>
								<select style={{
									marginBottom:"4em"
								}} onChange={(e)=>{
									const v = e.target.value
									setSelectedUserLimit(v)
								}}>
									<option value={''}>
										{t('ECOMMERCE.COMMON.ALL')}
									</option>
									{userLimits.map(((v, index) => {
										return (
											<option value={v} key={index}>
												{v} {t('User')}
											</option>
										)
									}))}
								</select>
								<select defaultValue={selectedMonth} onChange={(e) => {
									const value = Number(e.target.value)
									setSelectedMonth(value)
									switch (value) {
										case 1:
											setSelectedPercent(1)
											break;
										case 3:
											setSelectedPercent(0.9)
											break;
										case 6:
											setSelectedPercent(0.85)
											break;
										case 9:
											setSelectedPercent(0.8)
											break;
										case 12:
											setSelectedPercent(0.75)
											break;
									}
								}}>
									<option value={1}> 1{t('Months')} ({t('None')} {t('Discount')})</option>
									<option value={3}> 3{t('Months')} ({t('10%')} {t('Discount')})</option>
									<option value={6}> 6{t('Months')} ({t('15%')} {t('Discount')})</option>
									<option value={9}> 9{t('Months')} ({t('20%')} {t('Discount')})</option>
									<option value={12}> 1{t('Years')} ({t('25%')} {t('Discount')})</option>
								</select>
							</div>
							<ul>
								{plans.filter(q=>{
									if(queryField && queryField.qPlanId) {
										return q.public_id === queryField.qPlanId
									}
									return true
								})
									.filter(q => selectedVideoLimit === '' ? true : q.video_limit === Number(selectedVideoLimit))
									.filter(q => selectedUserLimit === '' ? true : q.max_user === Number(selectedUserLimit))
									.map(((plan) => {
									const isSelected = selectedPlan && selectedPlan.public_id === plan.public_id
									return (
										<li key={plan.public_id} className={`plan-item ${isSelected ? 'active' : ''}`}>
											<h5>{plan.name} {t('User')}</h5>
											<div className={'plan-details'}>
												<ul>
													<li>{plan.video_limit} {t('ConcurrentLiveVideo')}</li>
													<li>{plan.max_user} {t('ConcurrentUser')}</li>
													<li>{t('UnlimitedRooms')}</li>
													<li>{t('SpecialPanel')}</li>
													<li>{t('ConcurrentEvent')}</li>
													<li>{t('24-HourSupport')}</li>
												</ul>
											</div>
											<div className={'plan-btns'}>
												{selectedPercent !== 1 && <em>{digits(Math.round(plan.finalAmount  * selectedMonth))}  {t('Tooman')}</em>}
												<strong>{digits(Math.round(plan.finalAmount * selectedPercent * selectedMonth))}  {t('Tooman')}</strong>
												<button onClick={()=>{setSelectedPlan(isSelected ? null : plan)}}>{isSelected ? t('Cancel') : t('Select')}</button>
											</div>
										</li>
									)
								}))}
							</ul>
							{queryField && queryField.qPlanId ? (
								<Button size={"large"}  onClick={()=>{
									setQueryFields(prev=>({...prev,qPlanId:0}))
								}} variant="secondary mb-5 mx-5" style={{
									background: "#1aaea7",
									color: "white",
									display:"block",
									margin:"0 auto"
								}}>{t('ViewAllPlans')}</Button>
							) : ''}
						</div>
					)}

					{activeStep === 1 && (
						<Invoice
							id = ''
							date ={moment().format("HH:mm jYYYY/jMM/jDD")}
							transaction = ''
							amount ={selectedPlan ? (selectedPlan.finalAmount * selectedPercent * selectedMonth) : 0}
							name ={selectedPlan ? `${selectedPlan.name} - ${selectedMonth} ${t('Months')} `: ''}
							onSetCoupon={(code)=>{
								setCoupon(code)
							}}
						/>
					)}

					{activeStep === 2 && (
						<>
							<div className="container">
								<div className="row">
									<div className="col-md-6 mx-auto mt-5">
										<div className="payment">
											<div className={`payment_header ${queryField && queryField.qState !== 'OK' ? 'fail' :''}`}>
												<div className="check"> <i className={`fa ${queryField && queryField.qState !== 'OK' ? 'fa-times' : 'fa-check'}`} aria-hidden="true"/></div>
											</div>
											<div className="content">
												<h1>{queryField && queryField.qState === 'OK' ? t('SuccessfulPayment') : t('UnSuccessfulPayment') }</h1>
												<p>
													{queryField  && (
														<ul>
															<li> {t('InvoiceID')} : {queryField.qTransactionId}</li>

															{ queryField.qState !== 'OK' && queryField.qErrCode &&
																<>
																	<li>خطا : {queryField.qErr}</li>
																	<li>کد خطا : {queryField.qErrCode}</li>
																</>
															}
														</ul>
													)}

												</p>
												<a href="#" onClick={handleOpen} className={'help'}>
													<span></span>
													<span></span>
													<span></span>
													<span></span>
													{t('SeeGuide')}
												</a>
												{/*<br/>*/}
												{/*{queryField && queryField.qState === 'OK' ? <Link to="/room">
													<span></span>
													<span></span>
													<span></span>
													<span></span>
													{t('BuildFirstRoom')}</Link> : ''}*/}
											</div>

											<Modal
												aria-labelledby="transition-modal-title"
												aria-describedby="transition-modal-description"
												className={classes.modal}
												open={open}
												onClose={handleClose}
												closeAfterTransition
												BackdropComponent={Backdrop}
												BackdropProps={{
													timeout: 500,
												}}
											>
												<Fade in={open}>
													<div>
														<video style={{
															margin: "0 auto",
															display: "block"
														}} width="95%"  controls>
															<source src={t('lang') === 'fa' ? 'https://bellmeet.com/helpvideo/15.mp4' : 'https://bellmeet.com/helpvideo/16.mp4'} type="video/mp4" />
															Your browser does not support the video tag.
														</video>
													</div>
												</Fade>
											</Modal>
										</div>
									</div>
								</div>
							</div>
						</>
					)}

					<div className="text-center my-10">
						<div>
							<Button
								variant="contained"
								color="primary"
								onClick={activeStep !== 1 ? handleNext : handlePay}
								disabled={activeStep === 2 || isPaymentEnd || payFormLoading}
								className={classes.button}
								size="large"
							>
								{activeStep === 1 ? t('Payment') : t('NextPage')}
							</Button>
							<Button
								disabled={activeStep === 0 || isPaymentEnd || payFormLoading}
								onClick={()=> {
									if(activeStep === 2 && (queryField && queryField.qState !== 'OK')) return handleBack(0)
									handleBack()
								}}
								className={classes.button}
								variant="contained"
								size="large"
								color="primary"
							>
								{t('PreviousPage')}
							</Button>
						</div>
					</div>
				</div>
			</div>
		</>
	)
};